import { Injectable } from "@angular/core";
import { ConnectionStatus } from "./model/ConnectionStatus";
import { Observable } from "rxjs";

export const CHANNEL_CONNECTION_STATUS: string = "ConnectionStatusChannel";

export interface IConnectionStatusService {
  getConnectionEvents(): Observable<ConnectionStatus>;

  isConnectionActive(): Promise<ConnectionStatus>;
}
